import { useMemo } from 'react';

import Seo from '@/components/shared/Seo';

const ShopSeo = () => {
  const meta = useMemo(() => {
    const year = new Date().getFullYear();
    const title = `Online cashback offers & deals ${year} | Cashrewards`;
    const description = `Australia best online cashback offers, deals, vouchers & promo codes from over 1,200 retailers & start saving today. Why wouldn't you?`;
    return {
      description,
      title,
    };
  }, []);
  return (
    <Seo description={meta.description} title={meta.title} type='product' />
  );
};

export default ShopSeo;
